module.exports = __webpack_public_path__ + "static/media/about.3ea68ebd.png";